import { of } from 'rxjs'
import { pluck, filter, tap } from 'rxjs/operators'
import { notificationDismiss } from '@/service/notification'

const redirectToLink = routerPush => async ({ message: path, _id: id }) => {
  await routerPush({ path })
  await notificationDismiss(id)
}

export const redirect = routerPush => notifications => {
  const notifications$ = of(notifications)

  notifications$
    .pipe(
      pluck('redirect'),
      filter(redirect => redirect),
      tap(redirectToLink(routerPush))
    )
    .subscribe()

  return notifications$
}
